/**
 * ULLENBOOM® Baby – Varianten-Galerie & Größen-Buttons
 *
 * Dieses Script ermöglicht auf Kategorieseiten:
 * - Bildergalerie pro Produktkarte mit Pfeilen & Swipe
 * - Größen-Buttons die das Bild zur gewählten Variante wechseln
 * - Produktlink wird auf die gewählte Variante umgebogen
 *
 * Wird aktiviert durch: window.__enableCollectionVariantGallery = true
 * (gesetzt in snippets/ullenboom-head.liquid)
 */

if (window.__enableCollectionVariantGallery) {

  // Hilfsfunktion: nur sichtbare Slides zurückgeben (respektiert das 4er-Limit)
  function getVisibleSlides(gallery) {
    return Array.from(
      gallery.querySelectorAll('.ProductCard__Slide')
    ).filter(slide => slide.style.display !== 'none');
  }

  // Hilfsfunktion: passende Slide im Karussell zeigen
  function showVariantMedia(card, variantMediaId) {
    if (!variantMediaId) return;

    const gallery = card.querySelector('[data-product-gallery]');
    if (!gallery) return;

    const slides = getVisibleSlides(gallery);
    if (!slides.length) return;

    let targetFound = false;

    slides.forEach(function (slide) {
      const mediaId = slide.getAttribute('data-media-id');
      const isTarget = mediaId === variantMediaId;
      if (isTarget) targetFound = true;
      slide.classList.toggle('is-active', isTarget);
    });

    // Fallback: wenn keine passende Slide gefunden → erste Slide aktiv
    if (!targetFound) {
      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === 0);
      });
    }
  }

  // Beim Laden: aktiven Button auswerten und passendes Bild zeigen
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ProductItem, .product-card, .card').forEach(function (card) {
      const activeButton =
        card.querySelector('.ProductCard__SizeButton--active') ||
        card.querySelector('.ProductCard__SizeButton');

      if (!activeButton) return;

      const variantMediaId = activeButton.getAttribute('data-variant-media-id');
      if (variantMediaId) {
        showVariantMedia(card, variantMediaId);
      }
    });
  });

  // Klick auf Größen-Button
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.ProductCard__SizeButton');
    if (!button) return;

    const card = button.closest('.ProductItem, .product-card, .card');
    if (!card) return;

    const variantId = button.getAttribute('data-variant-id');
    const variantMediaId = button.getAttribute('data-variant-media-id');

    // Active-State umschalten
    card.querySelectorAll('.ProductCard__SizeButton--active').forEach(function (btn) {
      btn.classList.remove('ProductCard__SizeButton--active');
    });
    button.classList.add('ProductCard__SizeButton--active');

    // Zum passenden Bild im Karussell springen
    if (variantMediaId) {
      showVariantMedia(card, variantMediaId);
    }

    // Links in der Karte auf die gewählte Variante umbiegen
    if (variantId) {
      const links = card.querySelectorAll('a[href*="/products/"]');
      links.forEach(function (link) {
        try {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('variant', variantId);
          link.href = url.toString();
        } catch (e) {
          // ignorieren
        }
      });
    }
  });

  // Hilfsfunktion: Slides im Karussell wechseln
  function changeGallerySlide(gallery, directionOrIndex) {
    if (!gallery) return;

    // Nur sichtbare Slides berücksichtigen (respektiert das 4er-Limit)
    const slides = getVisibleSlides(gallery);
    if (!slides.length) return;

    let currentIndex = 0;

    slides.forEach(function (slide, index) {
      if (slide.classList.contains('is-active')) {
        currentIndex = index;
      }
    });

    let newIndex = currentIndex;

    if (directionOrIndex === 'next') {
      newIndex = (currentIndex + 1) % slides.length;
    } else if (directionOrIndex === 'prev') {
      newIndex = (currentIndex - 1 + slides.length) % slides.length;
    } else if (typeof directionOrIndex === 'number') {
      newIndex = Math.max(0, Math.min(slides.length - 1, directionOrIndex));
    }

    slides.forEach(function (slide, index) {
      slide.classList.toggle('is-active', index === newIndex);
    });
  }

  // Pfeil-Klicks fürs Karussell
  document.addEventListener('click', function (event) {
    const prevBtn = event.target.closest('[data-gallery-prev]');
    const nextBtn = event.target.closest('[data-gallery-next]');

    if (!prevBtn && !nextBtn) return;

    event.preventDefault();
    event.stopPropagation();

    const gallery = (prevBtn || nextBtn).closest('[data-product-gallery]');
    if (!gallery) return;

    if (prevBtn) {
      changeGallerySlide(gallery, 'prev');
    } else if (nextBtn) {
      changeGallerySlide(gallery, 'next');
    }
  });

  // Swipe für Touch-Geräte
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      let startX = null;

      gallery.addEventListener('touchstart', function (e) {
        if (!e.touches.length) return;
        startX = e.touches[0].clientX;
      }, { passive: true });

      gallery.addEventListener('touchend', function (e) {
        if (startX === null || !e.changedTouches.length) return;
        const endX = e.changedTouches[0].clientX;
        const diff = endX - startX;
        const threshold = 40;

        if (Math.abs(diff) > threshold) {
          changeGallerySlide(gallery, diff < 0 ? 'next' : 'prev');
        }

        startX = null;
      }, { passive: true });
    });
  });

}